import { render } from "./ResultList.vue?vue&type=template&id=a9dbb9d8&ts=true"
import script from "./ResultList.vue?vue&type=script&lang=ts"
export * from "./ResultList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__